export const TOTAL_CATEGORY_VALUE = 'total';

export const TOTAL_CATEGORY_OPTION = {
  value: TOTAL_CATEGORY_VALUE,
  label: 'Total',
} as const;
